import { checkinEn, checkinFi } from "./checkin";
import { commonEn, commonFi } from "./common";
import { dashboardEn, dashboardFi } from "./dashboard";
import { eventsEn, eventsFi } from "./events";
import { onboardingEn, onboardingFi } from "./onboarding";
import { settingsEn, settingsFi } from "./settings";
import { timelineEn, timelineFi } from "./timeline";
import { trendsEn, trendsFi } from "./trends";

export const resources = {
  en: {
    common: commonEn,
    onboarding: onboardingEn,
    settings: settingsEn,
    dashboard: dashboardEn,
    timeline: timelineEn,
    events: eventsEn,
    trends: trendsEn,
    checkin: checkinEn,
  },
  fi: {
    common: commonFi,
    onboarding: onboardingFi,
    settings: settingsFi,
    dashboard: dashboardFi,
    timeline: timelineFi,
    events: eventsFi,
    trends: trendsFi,
    checkin: checkinFi,
  },
} as const;

export const I18N_NAMESPACES = [
  "common",
  "onboarding",
  "settings",
  "dashboard",
  "timeline",
  "events",
  "trends",
  "checkin",
] as const;
